import BidderNetworkPerformanceHourlyV2 from './scenes/BidderNetworkPerformanceHourlyV2';
import PeerclickConversionsCutoff from './scenes/PeerclickConversionsCutoff';
import BidderNetworkPerformanceV2 from './scenes/BidderNetworkPerformanceV2';
import BitbucketDNSDomainChecker from './scenes/BitbucketDNSDomainChecker';
import AdkBannerDefaultOffersCpc from './scenes/AdkBannerDefaultOffersCpc';
import PeerclickCampaignUpdate from './scenes/PeerclickCampaignUpdate';
import ApkInstallationsHourly from './scenes/ApkInstallationsHourly';
import AdkBannerDefaultOffers from './scenes/AdkBannerDefaultOffers';
import DynamicHourlyCutoffAll from './scenes/DynamicHourlyCutoffAll';
import BidderSourcesWhitelist from './scenes/BidderSourcesWhitelist';
import PushapiPostbackHourly from './scenes/PushapiPostbackHourly';
import BidderClickUrlsHourly from "./scenes/BidderClickUrlsHourly";
import BidderClickUrlsDaily from "./scenes/BidderClickUrlsDaily";
import PushapiPostbackDaily from "./scenes/PushapiPostbackDaily";
import PeerClickOfferDomain from './scenes/PeerClickOfferDomain';
import AdkCountryHourFactor from './scenes/AdkCountryHourFactor';
import BidderSourcesCountry from './scenes/BidderSourcesCountry';
import BidderWinRateConfig from './scenes/BidderWinRateConfig';
import DynamicHourlyCutoff from './scenes/DynamicHourlyCutoff';
import ContentForYouHourly from './scenes/ContentForYouHourly';
import BidderSourcesConfig from './scenes/BidderSourcesConfig';
import PayoutCountryFactor from './scenes/PayoutCountryFactor';
import BidderManualOffers from './scenes/BidderManualOffers';
import PropellerAdsReport from './scenes/PropellerAdsReport';
import BidderSourcesGraph from './scenes/BidderSourcesGraph';
import AdContentArbitrage from './scenes/AdContentArbitrage';
import ContentForYouDaily from './scenes/ContentForYouDaily';
import BidderSourcesBlock from './scenes/BidderSourcesBlock';
import BidderECostCountry from './scenes/BidderECostCountry';
import BidderPluginReport from "./scenes/BidderPluginReport";
import AdkBannerPartners from './scenes/AdkBannerPartners';
import AdkQuickFactorAll from './scenes/AdkQuickFactorAll';
import ClickBaitMessages from './scenes/ClickBaitMessages';
import ApkInstallations from './scenes/ApkInstallations';
import DynamicCutoffAll from './scenes/DynamicCutoffAll';
import PushapiFactorAll from './scenes/PushapiFactorAll';
import BidderCpcCountry from './scenes/BidderCpcCountry';
import PayoutFactorAll from './scenes/PayoutFactorAll';
import AdkPartnerBlock from './scenes/AdkPartnerBlock';
import PushapiPartners from './scenes/PushapiPartners';
import BidderCtrHourly from './scenes/BidderCtrHourly';
import AdkBannerHourly from './scenes/AdkBannerHourly';
import AdkBidFactorAll from './scenes/AdkBidFactorAll';
import AdkPartnerGraph from './scenes/AdkPartnerGraph';
import PuhsapiExtended from './scenes/PushapiExtended';
import BidderFillRate from './scenes/BidderFillRate';
import CalendarEvents from './scenes/CalendarEvents';
import PartnerDomains from './scenes/PartnerDomains';
import AdkBannerDaily from './scenes/AdkBannerDaily';
import DummyCutoffAll from './scenes/DummyCutoffAll';
import AdkBannerFeeds from './scenes/AdkBannerFeeds';
import PushapiCountry from './scenes/PushapiCountry';
import AdkQuickFactor from './scenes/AdkQuickFactor';
import AdKernelHourly from './scenes/AdKernelHourly';
import BidderClickLog from './scenes/BidderClickLog';
import BidderHourlyV2 from './scenes/BidderHourlyV2';
import PushapiHourly from './scenes/PushapiHourly';
import Adk5MinFactor from './scenes/Adk5MinFactor';
import AdkHourFactor from './scenes/AdkHourFactor';
import DynamicCutoff from './scenes/DynamicCutoff';
import PushapiConfig from './scenes/PushapiConfig';
import PushapiCpcAll from './scenes/PushapiCpcAll';
import AdKernelDaily from './scenes/AdKernelDaily';
import PushapiFactor from './scenes/PushapiFactor';
import BidderSources from './scenes/BidderSources';
import BidderQuality from './scenes/BidderQuality';
import PushapiDaily from './scenes/PushapiDaily';
import ADKUnblocked from './scenes/ADKUnblocked';
import AdkBidFactor from './scenes/AdkBidFactor';
import PushapiBlock from './scenes/PushapiBlock';
import PayoutFactor from './scenes/PayoutFactor';
import BidderHourly from './scenes/BidderHourly';
import Notification from './scenes/Notification';
import UsersChanges from './scenes/UsersChanges';
import BidderFeeds from './scenes/BidderFeeds';
import AdkBoosters from './scenes/AdkBoosters';
import AdkCalculus from './scenes/AdkCalculus';
import AdkReferrer from './scenes/AdkReferrer';
import AdkHourlyV2 from './scenes/AdkHourlyV2';
import DummyCutoff from './scenes/DummyCutoff';
import AdkPartners from './scenes/AdkPartners';
import UsersCount2 from './scenes/UsersCount2';
import BidderECost from './scenes/BidderECost';
import BidderError from './scenes/BidderError';
import AdkDailyV3 from './scenes/AdkDailyV3';
import AdkDomains from "./scenes/AdkDomains";
import PushapiCpc from './scenes/PushapiCpc';
import BidderBids from './scenes/BidderBids';
import MasterCron from './scenes/MasterCron';
import UsersCount from './scenes/UsersCount';
import BidderSpy from './scenes/BidderSpy';
import SSRotator from './scenes/SSRotator';
import PushapiV3 from './scenes/PushapiV3';
import PushapiV2 from './scenes/PushapiV2';
import BidderCtr from './scenes/BidderCtr';
import BidderCpc from './scenes/BidderCpc';
import PcCutoff from './scenes/PcCutoff';
import AdkBlock from './scenes/AdkBlock';
import AdkLinks from './scenes/AdkLinks';
import AdkFeeds from './scenes/AdkFeeds';
import AdKernel from './scenes/AdKernel';
import ZeroPark from './scenes/ZeroPark';
import BidderV2 from './scenes/BidderV2';
import Segments from './scenes/Segments';
import History from './scenes/History';
import DomainsV2 from './scenes/DomainsV2';
import Domains from './scenes/Domains';
import AdkBids from './scenes/AdkBids';
import Servers from './scenes/Servers';
import Bidder2 from './scenes/Bidder2';
import Payouts from './scenes/Payouts';
import Filler from './scenes/Filler';
import Dating from './scenes/Dating';
import AkFull from './scenes/AkFull';
import Users from './scenes/Users';
import Sent from './scenes/Sent';
import Send from './scenes/Send';
import Home from './scenes/Home';

import AdkPartnerDomains from "./scenes/AdkPartnerDomains";
import AdkPreDefinedDomains from "./scenes/AdkPreDefinedDomains";
import AdkPartnerDomainReplacementLog from "./scenes/AdkPartnerDomainReplacementLog";
import AdkClickDomainReplacementLog from "./scenes/AdkClickDomainReplacementLog";

const Routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        icon: 'home'
    },
    {
        path: '/notification/:tagid/:archive?',
        name: 'Notification',
        component: Notification,
        notForNav: true
    },
    {
        type: 'folder',
        name: 'Misc',
        routes: [
            {
                path: '/send',
                name: 'Send',
                component: Send,
                icon: 'paper-plane-o'
            },
            {
                path: '/sent',
                name: 'Sent',
                component: Sent,
                icon: 'table'
            },
            {
                path: '/payouts',
                name: 'Payouts',
                component: Payouts,
                icon: 'money'
            },
            {
                path: '/masterCron',
                name: 'Master Cron',
                component: MasterCron,
                icon: 'table'
            },
            {
                path: '/segments',
                name: 'Segments',
                component: Segments,
                icon: 'table'
            },
            {
                path: '/ssRotator',
                name: 'SS Rotator',
                component: SSRotator,
                icon: 'table'
            },
            {
                path: '/servers',
                name: 'Servers',
                component: Servers,
                icon: 'table'
            },
            {
                path: '/domains',
                name: 'Domains',
                component: Domains,
                icon: 'table'
            },
            {
                path: '/domains_v2',
                name: 'Domains V2',
                component: DomainsV2,
                icon: 'table'
            },
            {
                path: '/partnerDomains',
                name: 'Partner Domains',
                component: PartnerDomains,
                icon: 'table'
            },
            {
                path: '/clickBaitMessages',
                name: 'Click Bait Messages',
                component: ClickBaitMessages,
                icon: 'table'
            },
            {
                path: '/dating',
                name: 'Dating',
                component: Dating,
                icon: 'table'
            },
            {
                path: '/history',
                name: 'History',
                component: History,
                icon: 'history'
            },
            {
                path: '/peerClickDomainUpdate',
                name: 'PeerClick Domain Update',
                component: PeerClickOfferDomain,
                icon: 'table'
            },
            {
                path: '/conversionsCutoff',
                name: 'ConversionCutoff Report',
                component: PeerclickConversionsCutoff,
                icon: 'table'
            },
            {
                path: '/peerclickCampaignUpdate',
                name: 'Peerclick Campaign Update',
                component: PeerclickCampaignUpdate,
                icon: 'table'
            },
            {
                path: '/bitbucket_dns_domain_checker',
                name: 'Webserver/Bitbucket/DNS Domains Checker',
                component: BitbucketDNSDomainChecker,
                icon: 'table'
            },
        ]
    },
    {
        type: 'folder',
        name: 'Main',
        routes: [
            {
                path: '/pcCutoff',
                name: 'PC Cutoff',
                component: PcCutoff,
                icon: 'cut'
            },
            {
                path: '/payoutFactor',
                name: 'Payout Factor',
                component: PayoutFactor,
                icon: 'table'
            },
            {
                path: '/payoutFactorAll',
                name: 'Payout Factor ALL',
                component: PayoutFactorAll,
                icon: 'table'
            },
            {
                path: '/payoutCountryFactor',
                name: 'Payout Country Factor',
                component: PayoutCountryFactor,
                icon: 'table'
            },
            {
                path: '/dynamicCutoff',
                name: 'Dynamic Cutoff',
                component: DynamicCutoff,
                icon: 'table'
            },
            {
                path: '/dynamicCutoffAll',
                name: 'Dynamic Cutoff All',
                component: DynamicCutoffAll,
                icon: 'table'
            },
            {
                path: '/dummyCutoff',
                name: 'Dummy Cutoff',
                component: DummyCutoff,
                icon: 'table'
            },
            {
                path: '/dummyCutoffAll',
                name: 'Dummy Cutoff ALL',
                component: DummyCutoffAll,
                icon: 'table'
            },
            {
                path: '/dynamicHourlyCutoff',
                name: 'Dynamic Hourly Cutoff',
                component: DynamicHourlyCutoff,
                icon: 'table'
            },
            {
                path: '/dynamicHourlyCutoffAll',
                name: 'Dynamic Hourly Cutoff All',
                component: DynamicHourlyCutoffAll,
                icon: 'table'
            },
        ]
    },
    {
        type: 'folder',
        name: 'Users',
        routes: [
            {
                path: '/users',
                name: 'Users',
                component: Users,
                icon: 'user'
            },
            {
                path: '/users/count',
                name: 'Count',
                component: UsersCount,
                icon: 'table'
            },
            {
                path: '/users/changes',
                name: 'Changes',
                component: UsersChanges,
                icon: 'table'
            },
            {
                path: '/users/count2',
                name: 'Count2',
                component: UsersCount2,
                icon: 'table'
            },
        ]
    },
    {
        type: 'folder',
        name: 'Bidder',
        routes: [
            {
                path: '/bidder_plugin_report',
                name: 'Plugin Report',
                component: BidderPluginReport,
                icon: 'table'
            },
            {
                path: '/bidder_click_urls_hourly',
                name: 'Click URL Hourly',
                component: BidderClickUrlsHourly,
                icon: 'table'
            },
            {
                path: '/bidder_click_urls_daily',
                name: 'Click URL Daily',
                component: BidderClickUrlsDaily,
                icon: 'table'
            },
            {
                path: '/bidderCpc',
                name: 'CPC',
                component: BidderCpc,
                icon: 'table'
            },
            {
                path: '/bidder2',
                name: 'Main Report',
                component: Bidder2,
                icon: 'table'
            },
            {
                path: '/bidderV2',
                name: 'Main Report V2',
                component: BidderV2,
                icon: 'table'
            },
            {
                path: '/bidderHourly',
                name: 'Main Hourly',
                component: BidderHourly,
                icon: 'table'
            },
            {
                path: '/bidderHourlyV2',
                name: 'Main Hourly V2',
                component: BidderHourlyV2,
                icon: 'table'
            },
            {
                path: '/bidderNetworkPerformanceHourly',
                name: 'Network Performance Hourly',
                component: BidderNetworkPerformanceHourlyV2,
                icon: 'table'
            },
            {
                path: '/bidderNetworkPerformance',
                name: 'Network Performance',
                component: BidderNetworkPerformanceV2,
                icon: 'table'
            },
            {
                path: '/contentForYouDaily',
                name: 'ContentForYou Daily',
                component: ContentForYouDaily,
                icon: 'table'
            },
            {
                path: '/contentForYouHourly',
                name: 'ContentForYou Hourly',
                component: ContentForYouHourly,
                icon: 'table'
            },
            {
                path: '/bidderError',
                name: 'Error',
                component: BidderError,
                icon: 'table'
            },
            {
                path: '/bidderECost',
                name: 'eCost',
                component: BidderECost,
                icon: 'table'
            },
            {
                path: '/bidderECostCountry',
                name: 'eCost Country',
                component: BidderECostCountry,
                icon: 'table'
            },
            {
                path: '/bidderCpcCountry',
                name: 'Cpc Country',
                component: BidderCpcCountry,
                icon: 'table'
            },
            {
                path: '/bidderQuality',
                name: 'Quality',
                component: BidderQuality,
                icon: 'table'
            },
            {
                path: '/bidderSources',
                name: 'Sources',
                component: BidderSources,
                icon: 'table'
            },
            {
                path: '/bidderSourcesCountry',
                name: 'Sources Country',
                component: BidderSourcesCountry,
                icon: 'table'
            },
            {
                path: '/bidderSourcesBlock',
                name: 'Sources Block',
                component: BidderSourcesBlock,
                icon: 'table'
            },
            {
                path: '/bidderSourcesWhitelist',
                name: 'Sources Whitelist',
                component: BidderSourcesWhitelist,
                icon: 'table'
            },
            {
                path: '/bidderClickLog',
                name: 'Click Log',
                component: BidderClickLog,
                icon: 'table'
            },
            {
                path: '/bidderCtr',
                name: 'CTR',
                component: BidderCtr,
                icon: 'table'
            },
            {
                path: '/bidderBids',
                name: 'Bids',
                component: BidderBids,
                icon: 'table'
            },
            {
                path: '/bidderSourcesGraph',
                name: 'Sources Graph',
                component: BidderSourcesGraph,
                icon: 'table'
            },
            {
                path: '/bidderFillRate',
                name: 'Fill Rate',
                component: BidderFillRate,
                icon: 'table'
            },
            {
                path: '/bidderCtrHourly',
                name: 'CTR Hourly',
                component: BidderCtrHourly,
                icon: 'table'
            },
            {
                path: '/bidderSpy',
                name: 'Spy',
                component: BidderSpy,
                icon: 'table'
            },
            {
                path: '/bidderManualOffers',
                name: 'Manual Offers',
                component: BidderManualOffers,
                icon: 'table'
            },
            {
                path: '/bidderWinRateConfog',
                name: 'Win Rate Config',
                component: BidderWinRateConfig,
                icon: 'table'
            },
            {
                path: '/bidderFeeds',
                name: 'Feeds',
                component: BidderFeeds,
                icon: 'table'
            },
            {
                path: '/bidderFiller',
                name: 'Filler',
                component: Filler,
                icon: 'table'
            },
            {
                path: '/bidderSourcesConfig',
                name: 'Sources Config',
                component: BidderSourcesConfig,
                icon: 'table'
            },
        ]
    },
    {
        type: 'folder',
        name: 'Pushapi',
        routes: [
            {
                path: '/pushapiExtended',
                name: 'Extended',
                component: PuhsapiExtended,
                icon: 'table'
            },
            {
                path: '/pushapiV2',
                name: 'Extended V2',
                component: PushapiV2,
                icon: 'table'
            },
            {
                path: '/pushapiV3',
                name: 'Extended V3',
                component: PushapiV3,
                icon: 'table'
            },
            {
                path: '/pushapiHourly',
                name: 'Hourly',
                component: PushapiHourly,
                icon: 'table'
            },
            {
                path: '/pushapiDaily',
                name: 'Daily',
                component: PushapiDaily,
                icon: 'table'
            },
            {
                path: '/pushapiPostbackHourly',
                name: 'Postback Hourly',
                component: PushapiPostbackHourly,
                icon: 'table'
            },
            {
                path: '/pushapiPostbackDaily',
                name: 'Postback Daily',
                component: PushapiPostbackDaily,
                icon: 'table'
            },
            {
                path: '/pushapiFactor',
                name: 'Factor',
                component: PushapiFactor,
                icon: 'table'
            },
            {
                path: '/pushapiFactorAll',
                name: 'Factor All',
                component: PushapiFactorAll,
                icon: 'table'
            },
            {
                path: '/pushapiCpc',
                name: 'Cpc',
                component: PushapiCpc,
                icon: 'table'
            },
            {
                path: '/pushapiCpcAll',
                name: 'Cpc All',
                component: PushapiCpcAll,
                icon: 'table'
            },
            {
                path: '/pushapiConfig',
                name: 'Config',
                component: PushapiConfig,
                icon: 'table'
            },
            {
                path: '/pushapiPartners',
                name: 'Partners',
                component: PushapiPartners,
                icon: 'table'
            },
            {
                path: '/pushapiBlock',
                name: 'Block',
                component: PushapiBlock,
                icon: 'table'
            },
            {
                path: '/pushapiCountry',
                name: 'Country',
                component: PushapiCountry,
                icon: 'table'
            },
        ]
    },
    {
        type: 'folder',
        name: 'ADK',
        routes: [
            {
                path: '/adkFeeds',
                name: 'Feeds',
                component: AdkFeeds,
                icon: 'table'
            },
            {
                path: '/adkDomains',
                name: 'ADK Domains',
                component: AdkDomains,
                icon: 'table'
            },
            {
                path: '/adkPartnerDomains',
                name: 'ADK Partner Domains',
                component: AdkPartnerDomains,
                icon: 'table'
            },
            {
                path: '/adkPreDefinedDomains',
                name: 'ADK Pre Defined Domains',
                component: AdkPreDefinedDomains,
                icon: 'table'
            },
            {
                path: '/adkPartnerDomainReplacementLog',
                name: 'ADK Partner Replacement Log',
                component: AdkPartnerDomainReplacementLog,
                icon: 'table'
            },
            {
                path: '/adkClickDomainReplacementLog',
                name: 'ADK Click Replacement Log',
                component: AdkClickDomainReplacementLog,
                icon: 'table'
            },
            {
                path: '/adkUnblocked',
                name: 'ADK Unblocked',
                component: ADKUnblocked,
                icon: 'table'
            },
            {
                path: '/adkLinks',
                name: 'Links',
                component: AdkLinks,
                icon: 'table'
            },
            {
                path: '/adkBids',
                name: 'Bids',
                component: AdkBids,
                icon: 'table'
            },
            {
                path: '/adkBoosters',
                name: 'Boosters',
                component: AdkBoosters,
                icon: 'table'
            },
            {
                path: '/adkPartnerGraph',
                name: 'Partner Graph',
                component: AdkPartnerGraph,
                icon: 'table'
            },
            {
                path: '/adkHourly',
                name: 'Hourly',
                component: AdkHourlyV2,
                icon: 'table'
            },
            {
                path: '/adkDaily',
                name: 'Daily',
                component: AdkDailyV3,
                icon: 'table'
            },
            {
                path: '/adkBidFactor',
                name: 'Bid Factor',
                component: AdkBidFactor,
                icon: 'table'
            },
            {
                path: '/adkBidFactorAll',
                name: 'Bid Factor All',
                component: AdkBidFactorAll,
                icon: 'table'
            },
            {
                path: '/adkQuickFactor',
                name: 'Quick Factor',
                component: AdkQuickFactor,
                icon: 'table'
            },
            {
                path: '/adkQuickFactorAll',
                name: 'Quick Factor All',
                component: AdkQuickFactorAll,
                icon: 'table'
            },
            {
                path: '/adkBlock',
                name: 'Block',
                component: AdkBlock,
                icon: 'table'
            },
            {
                path: '/adkPartnerBlock',
                name: 'Partner Block',
                component: AdkPartnerBlock,
                icon: 'table'
            },

            {
                path: '/adkPartners',
                name: 'Partners',
                component: AdkPartners,
                icon: 'table'
            },
            {
                path: '/adkHourFactor',
                name: 'Hour Factor',
                component: AdkHourFactor,
                icon: 'table'
            },
            {
                path: '/adkCountryHourFactor',
                name: 'Country Hour Factor',
                component: AdkCountryHourFactor,
                icon: 'table'
            },
            {
                path: '/adkReferrer',
                name: 'ADK Referrer',
                component: AdkReferrer,
                icon: 'table'
            },
            {
                path: '/adk5MinFactor',
                name: 'ADK 5 Min Factor',
                component: Adk5MinFactor,
                icon: 'table'
            },
            {
                path: '/adkCalculus',
                name: 'ADK Calculus',
                component: AdkCalculus,
                icon: 'table'
            },
        ]
    },
    {
        type: 'folder',
        name: 'ADK Banner',
        routes: [
            {
                path: '/adkBannerFeeds',
                name: 'Feeds',
                component: AdkBannerFeeds,
                icon: 'table'
            },
            {
                path: '/adkBannerPartners',
                name: 'Partners',
                component: AdkBannerPartners,
                icon: 'table'
            },
            {
                path: '/adkBannerHourly',
                name: 'Hourly',
                component: AdkBannerHourly,
                icon: 'table'
            },
            {
                path: '/adkBannerDaily',
                name: 'Daily',
                component: AdkBannerDaily,
                icon: 'table'
            },
            {
                path: '/adkBannerDefaultOffers',
                name: 'Default Offers',
                component: AdkBannerDefaultOffers,
                icon: 'table'
            },
            {
                path: '/adkBannerDefaultOffersCpc',
                name: 'Default Offers Cpc',
                component: AdkBannerDefaultOffersCpc,
                icon: 'table'
            },
        ]
    },
    {
        type: 'folder',
        name: 'Calendar',
        routes: [
            {
                path: '/calendar/events',
                name: 'Events',
                component: CalendarEvents,
                icon: 'table'
            },
        ]
    },
    {
        type: 'folder',
        name: 'Propeller Ads',
        routes: [
            {
                path: '/propellerAdsReport',
                name: 'Report',
                component: PropellerAdsReport,
                icon: 'table'
            }
        ]
    },
    {
        path: '/zeroPark',
        name: 'ZeroPark',
        component: ZeroPark,
        icon: 'table'
    },
    {
        path: '/adKernel',
        name: 'AdKernel',
        component: AdKernel,
        icon: 'table'
    },
    {
        path: '/adKernelHourly',
        name: 'Ad Kernel Hourly',
        component: AdKernelHourly,
        icon: 'table'
    },
    {
        path: '/adKernelDaily',
        name: 'Ad Kernel Daily',
        component: AdKernelDaily,
        icon: 'table'
    },
    {
        path: '/akFull',
        name: 'AK Full',
        component: AkFull,
        icon: 'table'
    },
    {
        path: '/adContentArbitrage',
        name: 'Ad Content Arbitrage',
        component: AdContentArbitrage,
        icon: 'table'
    },
    {
        path: '/apkInstallations',
        name: 'APK Installations Report',
        component: ApkInstallations,
        icon: 'table'
    },
    {
        path: '/apkInstallationsHourly',
        name: 'APK Installations Hourly Report',
        component: ApkInstallationsHourly,
        icon: 'table'
    }
];

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js